import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { markFormGroupTouched } from '@core/helpers';
import { StepComponent } from '../interfaces/step-component';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class StepMenuService {
  private changeStepSource = new Subject<string>();
  changeStep$ = this.changeStepSource.asObservable();

  formsSubject = new BehaviorSubject<FormGroup[]>([]);
  forms$ = this.formsSubject.asObservable();

  instancesSubject = new BehaviorSubject<StepComponent[]>([]);
  instances$ = this.instancesSubject.asObservable();

  formValidSubject = new BehaviorSubject<boolean>(false);
  formValid$ = this.formValidSubject.asObservable();

  constructor() {}

  changeStep(step: string): void {
    this.changeStepSource.next(step);
  }

  registerForm(instance: StepComponent): void {
    this.instancesSubject.next([
      ...this.instancesSubject.getValue(),
      instance
      // ...new Set([...this.instancesSubject.getValue(), instance]),
    ]);
  }

  isFormValid(): boolean {
    [...this.instancesSubject.getValue()].map((instance) => {
      if (instance?.formGroup) {
        markFormGroupTouched(instance.formGroup, true);

        instance.formGroup.valueChanges.subscribe(() => {
          this.formValidSubject.next(
            [...this.instancesSubject.getValue()]
              .filter((instance) => !!instance.formGroup)
              .every((instance) => !!instance.formGroup.valid)
          );
        });
      }
    });

    this.instancesSubject.next([...this.instancesSubject.getValue()]);

    return [...this.instancesSubject.getValue()]
      .filter((instance) => !!instance.formGroup)
      .every((instance) => !!instance.formGroup.valid);
  }

  // validateForms(): void {
  //   for (const component of this.instancesSubject.getValue()) {
  //     if (component.formGroup)
  //       markFormGroupTouched(component.formGroup, true);
  //   }
  // }

  unregisterForm(id: number): void {
    this.instancesSubject.next(
      this.instancesSubject.getValue().filter((_, i) => id !== i)
    );
  }
}
